var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"news-sitebar order-lg-1",attrs:{"lg":"4","md":"12"}},[_c('div',{staticClass:"news-items"},_vm._l((_vm.newsitems),function(newsitem){return _c('NewsItem',{key:newsitem.id,attrs:{"newsitem":newsitem}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }